<template>
  <v-container grid-list-md fluid pa-0 class="table-container">
    <v-layout
      row
      wrap
      class="assignment-row"
      v-for="assignment in assignments"
      :key="assignment.id"
    >
      <v-flex xs12 sm12 md8 class="list-row">
        <card :assignment="assignment" :list="true"></card>
      </v-flex>
      <v-flex xs12 sm12 md4>
        <div class="more-content">
          <stats class="hidden-sm-and-down" :assignment="assignment"></stats>
          <todo-list class="hidden-sm-and-down" :assignment="assignment"></todo-list>
          <!-- <actions :assignment="assignment"></actions> -->
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Card from "./Card";
import Stats from "./Stats";
import Actions from "./Actions";
import TodoList from "./TinyTodoList";

export default {
  name: "List",
  components: { Card, Stats, Actions, TodoList },
  props: ["assignments"],
  mounted() {
    // console.log("using assignments", this.assignments);
  }
};
</script>

<style scoped>
.assignment-row {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.table-container {
  margin-top: 8px;
}
.more-content {
  padding-left: 12px;
}
.get-reviewed {
  float: left;
  background: #fdd835 !important;
  border-bottom: 0px solid #fbc02d;
  border-right: 0px solid #fbc02d;
  margin-left: 10px;
  margin-top: 28px;
  /*border: 2px solid #e3e3e3;*/
  /*border-bottom: 3px solid #c6c6c6;*/
  border-radius: 4px;
  padding: 8px 16px 9px 16px;
  font-size: 12pt;
  font-weight: 700;
  text-transform: none;
  color: #bc5100 !important;
  font-family: "Source Sans Pro";
  text-transform: uppercase;
  letter-spacing: 1px;
}

.list-row {
  padding-top: 0 !important;
}
</style>


